import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  connect() {
    // Verificar si Choices ya está inicializado en este elemento
    // Verificar tanto la propiedad choices como las clases CSS
    if (!this.element.choices && !this.element.classList.contains('choices__input')) {
      const choices = new Choices(this.element, {
        itemSelectText: '+',
        removeItemButton: true,
        searchEnabled: true,
        searchChoices: true,
        placeholder: true,
        placeholderValue: 'Buscar y seleccionar...',
        noResultsText: 'No se encontraron resultados',
        noChoicesText: 'No hay opciones disponibles'
      })

      // Guardar referencia para poder destruirla después
      this.element.choices = choices
    }
  }

  // NO incluir disconnect() - causa freeze en la vista de meals
}
